//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    bgHero: {
      type: String,
      default: "",
    },
    service: {
      type: String,
      default: "",
    },
    surtitle: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    btnText: {
      type: String,
      default: "",
    },
    maxWidthTitle: {
      type: String,
      default: "",
    },
  },
};
